<n-slide-window *ngIf="pageReady"
    [(visible)]="windowVisible"
    width="7rem"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.createTitle}}</h1>
        <n-help-link key="qoutaCreate"></n-help-link>
    </n-header>

    <n-block [title]="i18n.quotaObjectLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <!-- 所属租户 -->
            <n-form-item [label]="i18n.vStoreLab">
                <div class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- 文件系统 -->
            <n-form-item [label]="i18n.fileSystemLab">
                <div class="n-form-item-text">{{fileSystem?.NAME || UNPLACEHOLDER}}</div>
            </n-form-item>
            <!-- dtree -->
            <n-form-item [label]="i18n.dtreeLab" *ngIf="showDtree">
                <div class="text-wrap n-form-item-text">{{dtree?.NAME || UNPLACEHOLDER}}</div>
            </n-form-item>
        </form>
    </n-block>
    <n-block [title]="i18n.quotaTypeLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <!-- 配额类型 -->
            <n-form-item [label]="i18n.quotaTypeLab"
                [required]="true">
                <n-radio-group id="create-user-quota-type"
                    formControlName="quotaType"
                    [block]="true"
                    (onChange)="onQuotaTypeChange()">
                    <!-- 目录 -->
                    <n-radio [value]="QuotaTypeE.Dtree" *ngIf="!ProductConfig.isHideDtreeQuota">{{str.quotaTypeI18n[QuotaTypeE.Dtree]}}</n-radio>
                    <p class="sub pl-20" *ngIf="!ProductConfig.isHideDtreeQuota">{{vm.value.dtree ? i18n.selectedDtreeQuotaTip : i18n.dtreeQuotaTip}}</p>
                    <!-- 用户 -->
                    <n-radio [value]="QuotaTypeE.User">
                        <div class="interval-10">
                            <span>{{str.quotaTypeI18n[QuotaTypeE.User]}}</span>
                            <ng-container *ngIf="vmValue.quotaType === QuotaTypeE.User">
                                <a *ngIf="users === undefined" (click)="selectUser()">{{i18n.selectBtn}}</a>
                                <span *ngIf="users !== undefined">{{usersDesc}}</span>
                                <a *ngIf="users !== undefined" (click)="selectUser()">{{i18n.modifyBtn}}</a>
                            </ng-container>
                        </div>
                    </n-radio>
                    <p class="sub pl-20">{{i18n.userQuotaTip}}</p>
                    <n-tip *ngIf="userRequiredErr"
                        [type]="'failed'"
                        [content]="i18n.atLeastSelectOneTip">
                    </n-tip>
                    <!-- 用户组 -->
                    <n-radio [value]="QuotaTypeE.UserGroup">
                        <div class="interval-10">
                            <span>{{str.quotaTypeI18n[QuotaTypeE.UserGroup]}}</span>
                            <ng-container *ngIf="vmValue.quotaType === QuotaTypeE.UserGroup">
                                <a *ngIf="userGroups === undefined" (click)="selectUserGroup()">{{i18n.selectBtn}}</a>
                                <span *ngIf="userGroups !== undefined">{{userGroupsDesc}}</span>
                                <a *ngIf="userGroups !== undefined" (click)="selectUserGroup()">{{i18n.modifyBtn}}</a>
                            </ng-container>
                        </div>
                    </n-radio>
                    <p class="sub pl-20">{{i18n.userGroupQuotaTip}}</p>
                    <n-tip *ngIf="userGroupRequiredErr"
                        [type]="'failed'"
                        [content]="i18n.atLeastSelectOneTip">
                    </n-tip>
                </n-radio-group>
            </n-form-item>
        </form>
    </n-block>
    <!-- 空间配额 -->
    <n-block [title]="i18n.spaceQuotaLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <!-- 硬 -->
            <n-form-item [label]="i18n.hardQuotaLab"
                formGroupName="spaceQuota"
                [helpContent]="i18n.spaceHardQuotaTip">
                <div class="interval-10">
                    <n-capacity id="create-user-quota-hard-space-quota"
                        [units]="str.capacityUnits"
                        [nonDecimalUnits]="str.capacityUnits"
                        formControlName="hard">
                    </n-capacity>
                    <span>{{str.rangeTip | fn :str.spaceQuotaMin :str.spaceQuotaMax}}</span>
                </div>
            </n-form-item>
            <!-- 软 -->
            <n-form-item [label]="i18n.softQuotaLab"
                formGroupName="spaceQuota"
                [helpContent]="i18n.spaceSoftQuotaTip">
                <div class="interval-10">
                    <n-capacity id="create-user-quota-soft-space-quota"
                        [units]="str.capacityUnits"
                        [nonDecimalUnits]="str.capacityUnits"
                        formControlName="soft">
                    </n-capacity>
                    <span>{{str.rangeTip | fn :str.spaceQuotaMin :str.spaceQuotaMax}}</span>
                </div>
            </n-form-item>
        </form>
    </n-block>
    <!-- 文件数 -->
    <n-block [title]="i18n.fileQuotaLab">
        <form [errorMessage]="errorMessage"
            [formGroup]="vm"
            class="common-form">
            <!-- 硬 -->
            <n-form-item [label]="i18n.hardQuotaLab"
                formGroupName="fileQuota"
                [helpContent]="i18n.fileHardQuotaTip">
                <div class="interval-10">
                    <n-spinner id="create-user-quota-hard-file-quota"
                        [min]="str.fileQuotaMin"
                        [max]="vm.get('fileQuota.hardUnit').value | unitTransform :str.fileQuotaMax :'num'"
                        [onlyInput]="true"
                        [required]="false"
                        style="width: 1.8rem;"
                        formControlName="hard">
                    </n-spinner>
                    <n-select style="width:1.1rem"
                        class="ml-10"
                        [options]="str.fileQuotaUnits"
                        formControlName="hardUnit"
                        id="create-user-quota-soft-file-hardUnit">
                    </n-select>
                    <span>{{str.fileQuotaRange | fn :'1' :i18nService.language === 'zh' ? '20' : '2'}}</span>
                </div>
            </n-form-item>
            <!-- 软 -->
            <n-form-item [label]="i18n.softQuotaLab"
                formGroupName="fileQuota"
                [helpContent]="i18n.fileSoftQuotaTip">
                <div class="interval-10">
                    <n-spinner id="create-user-quota-soft-file-quota"
                        [min]="str.fileQuotaMin"
                        [max]="vm.get('fileQuota.softUnit').value | unitTransform :str.fileQuotaMax :'num'"
                        [onlyInput]="true"
                        [required]="false"
                        style="width: 1.8rem;"
                        formControlName="soft">
                    </n-spinner>
                    <n-select style="width:1.1rem"
                        class="ml-10"
                        [options]="str.fileQuotaUnits"
                        formControlName="softUnit"
                        id="create-user-quota-soft-file-softUnit">
                    </n-select>
                    <span>{{str.fileQuotaRange | fn :'1' :i18nService.language === 'zh' ? '20' : '2'}}</span>
                </div>
            </n-form-item>
        </form>
    </n-block>

    <n-footer>
        <button id="create-user-quota-ok-btn"
            nButton
            theme="primary"
            [label]="i18n.okBtn"
            (click)="onOk()">
        </button>
        <button id="create-user-quota-cancel-btn"
            nButton
            [label]="i18n.cancelBtn"
            (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
